/**
 * Tunable thresholds for the calendar's validation signals. Hardcoding
 * these inside the derive functions makes them painful to revisit; one
 * file makes them findable + testable.
 */

/** Coverage warning ribbon thresholds, expressed as `out / headcount`. */
export const COVERAGE_THRESHOLDS = {
  medium: 0.30,
  high: 0.50,
} as const
